var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bannerImage)?_c('div',{staticClass:"banner-container"},[_c('img',{staticClass:"banner-image",class:{ 'small': _vm.isMobile },attrs:{"src":_vm.bannerImage,"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }